import { api } from "@/lib/api/api";
import type { ApiOutputs } from "@/lib/api/api-outputs";
import { expectShape } from "@/lib/expect/expect-shape";
import { path } from "@/lib/path/path";
import { out } from "@/lib/output/out";

export async function trashSession(
  sessionId: string,
  asJson: boolean,
): Promise<void> {
  const result = expectShape<ApiOutputs["sessions"]["trash"]>(
    await api(path`/sessions/${sessionId}`, { method: "DELETE" }),
    "DELETE /sessions/{id}",
    {
      sessionId: (value) => value === sessionId,
      deletedAt: (value) =>
        value === null ||
        (typeof value === "string" && Number.isFinite(Date.parse(value))),
    },
  );
  if (asJson) {
    out.json(result);
    return;
  }
  out.line(`Trashed ${out.safe(result.sessionId)}`);
}
